import {forwardRef} from "react";
import classes from "./form-elements.module.css";

interface DropdownMenuProps {
    children: React.ReactNode[];
    isOpen: boolean;
}

export const DropdownMenu = forwardRef<HTMLUListElement, DropdownMenuProps>(
    ({children, isOpen, ...rest}, ref) => (
        <ul
            ref={ref}
            className={`${classes.dropdownMenu}${isOpen ? ` ${classes.isOpen}` : ""}`}
            {...rest}
        >
            {isOpen ? children : null}
        </ul>
    )
);

DropdownMenu.displayName = "DropdownMenu";
